import * as XGSIcons from "@fortawesome/free-solid-svg-icons";

export default XGSIcons;
